import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const EurosFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Cuenta EUR' htmlFor='input-euros' md={12} />
      <Col md={12}>
        <Field name='cuentaContable12EUR'>
          {({ field }) => <Form.InputText {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-euros' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EurosFormGroup)
